import GithubCard from "./github_card.js";
console.log(GithubCard);
export { GithubCard };
